export { default } from './head.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/first.js
// module id = 641
// module chunks = 67